<template>
	<node-edit-name></node-edit-name>
	<node-edit-bar
		@option-set="optionSet"
	></node-edit-bar>
	<node-edit-template v-if="isBarTemplateActive"></node-edit-template>
	<node-edit-design v-if="isNodeBarDesignActive"></node-edit-design>
	<node-edit-content v-if="isNodeBarContentActive"></node-edit-content>
	<node-edit-link v-if="isNodeBarLinkActive"></node-edit-link>
	<node-edit-visibility v-if="isNodeBarVisibilityActive"></node-edit-visibility>
	<node-edit-navigation v-if="isNodeBarNavigationActive"></node-edit-navigation>
</template>

<script>
import NodeEditName from './modules/NodeEditName';
import NodeEditBar from './modules/NodeEditBar';
import NodeEditLink from './modules/NodeEditLink';
import NodeEditVisibility from './modules/NodeEditVisibility';
import NodeEditNavigation from './modules/NodeEditNavigation';
import {computed, ref} from 'vue';
import {NODE_EDIT_BAR_OPTIONS} from '@/models/edit-bar/NODE_EDIT_BAR_OPTIONS';
import {useStore} from 'vuex';
import NodeEditContent from './modules/NodeEditContent';
import NodeEditDesign from './modules/NodeEditDesign';
import {DASHBOARD_OPTIONS} from '@/models/DASHBOARD_OPTIONS';
import NodeEditTemplate from "./modules/NodeEditTemplate";
export default {
	components: {
		NodeEditTemplate,
		NodeEditDesign,
		NodeEditContent, NodeEditNavigation, NodeEditVisibility, NodeEditLink, NodeEditBar, NodeEditName
	},
	setup() {
		const store = useStore();
		
		const optionActive = ref(null);
		function optionSet(option){
			optionActive.value = optionActive.value === option ? null : option;
		}
		
		const NODE_DESIGN = DASHBOARD_OPTIONS.CREATE.GROUPS.NODE.NODE_DESIGN;
		const TEMPLATE_OPTION = {VALUE: 'TEMPLATE', TYPE: 'TEMPLATE', ICON: null, ACTION: null};
		const currentNode = computed(() => store.getters['nodes/getSelectedNode']);
		const nodeEditingContent = computed(() => !!currentNode.value.editingContent);
		const optionDashboardActive = computed(() => store.getters["dashboardOptions/getOptionActive"]);
		const isNodeDesignSettingsOpened = computed(() => optionDashboardActive.value?.VALUE === NODE_DESIGN.VALUE);
		
		const isBarTemplateActive = computed(() => optionActive.value === TEMPLATE_OPTION.VALUE);
		const isNodeBarDesignActive = computed(() => optionActive.value === NODE_EDIT_BAR_OPTIONS.DESIGN.VALUE);
		const isNodeBarContentActive = computed(() => optionActive.value === NODE_EDIT_BAR_OPTIONS.CONTENT.VALUE && !isNodeDesignSettingsOpened.value);
		const isNodeBarLinkActive = computed(() => optionActive.value === NODE_EDIT_BAR_OPTIONS.LINK.VALUE);
		const isNodeBarVisibilityActive = computed(() => optionActive.value === NODE_EDIT_BAR_OPTIONS.VISIBILITY.VALUE)
		const isNodeBarNavigationActive = computed(() => optionActive.value === NODE_EDIT_BAR_OPTIONS.NAVIGATION.VALUE)
		
		return {
			isNodeBarLinkActive,
			isNodeBarVisibilityActive,
			isNodeBarNavigationActive,
			isNodeBarContentActive,
			isNodeBarDesignActive,
			isBarTemplateActive,
			optionSet,
			nodeEditingContent
		}
	}
}
</script>

<style lang="scss">

</style>
